import {getGender} from "@/util";

/** 交易类型code 认购 0 */
const subscribeCode = '0'
/** 交易类型code 申购 1 */
const subscriptionCode = '1'
/** 交易类型code 赎回 2 */
const redeemCode = '2'
/** 交易类型code 分红 8 */
const bonusCode = '8'
/** 交易类型code transfer_in: {code: '300', name: '份额转入'}, */
const transferInCode = '300'
/** 交易类型code transfer_out: {code: '301', name: '份额转出'}, */
const transferOutCode = '301'
/** 交易类型code reward_deduction_share: {code: '102', name: '业绩报酬（扣份额）'} */
const rewardDeductionShareCode = '102'
/** 交易类型code reward_deduction_amout: {code: '103', name: '业绩报酬'} //业绩报酬 */
const rewardDeductionAmoutCode = '103'
/** 交易类型code reward_deduction_amout: {code: '103', name: '业绩报酬'} //清算 */
const liquidationCode = '150'
/** 交易类型code reward_deduction_amout: {code: '103', name: '业绩报酬'} //结息 */
const interestSettlementCode = '350'
/** 交易类型name 认购 0 */
const subscribeName = '认购'
/** 交易类型name 申购 1 */
const subscriptionName = '申购'
/** 交易类型name 赎回 2 */
const redeemName = '赎回'
/** 交易类型name 分红 8 */
const bonusName = '分红'
/** 交易类型name transfer_in: {code: '300', name: '份额转入'}, */
const transferInName = '份额转入'
/** 交易类型name transfer_out: {code: '301', name: '份额转出'}, */
const transferOutName = '份额转出'
/** 交易类型name reward_deduction_share: {code: '102', name: '业绩报酬'} */
const rewardDeductionShareName = '业绩报酬'
/** 交易类型name reward_deduction_amout: {code: '103', name: '业绩报酬'} //业绩报酬 */
const rewardDeductionAmoutName = '业绩报酬'
// todo 红利转投
const hongLiZhuangTouName = '红利转投'
/** 清算 */
const liquidationName = '清算'
/** 结息 */
const interestSettlementName = '结息'
const fundConversionTransferCode = '320';
const fundConversionTransferName = '基金转换转出';


/** 交易类型name addName: {code: '', name: '追加'} //业绩报酬 */
const addName = '追加'

/**
 * 交易类型
 * @type {{subscribe: {code: string, name: string}, bonus: {code: string, name: string}, reward_deduction_share: {code: string, name: string}, redeem: {code: string, name: string}, subscription: {code: string, name: string}, transfer_out: {code: string, name: string}, transfer_in: {code: string, name: string}, reward_deduction_amout: {code: string, name: string}}}
 */
const constant_trade_type = {
  subscribe: {code: subscribeCode, name: subscribeName},
  subscription: {code: subscriptionCode, name: subscriptionName},
  redeem: {code: redeemCode, name: redeemName}, // "赎回"
  bonus: {code: bonusCode, name: bonusName}, //这个需要根据实际情况，不可以直接使用 现金分红（有确认金额，无确认份额）   红利转投（有确认金额，有确认份额）
  transfer_in: {code: transferInCode, name: transferInName},
  transfer_out: {code: transferOutCode, name: transferOutName},
  reward_deduction_share: {code: rewardDeductionShareCode, name: rewardDeductionShareName},//业绩报酬提取（扣份额）
  reward_deduction_amout: {code: rewardDeductionAmoutCode, name: rewardDeductionAmoutName}, //业绩报酬
  liquidation: {code: liquidationCode, name: liquidationName}, //清算
  interest_settlement : {code: interestSettlementCode, name: interestSettlementName}, //结息
  fundConversionTransfer: {code: fundConversionTransferCode, name: fundConversionTransferName}, // 基金转换转出
  convert_into: {code: '310', name: '基金转换转入'}, // 基金转换转入
}

/** self_manager: {code: '0', name: '自主发行'}, */
const fundTypeBySelfManger = '0'
/** advisor : {code : '1', name: '投顾型'}  */
const fundTypeByAdvisor = '1'
/**
 * todo 产品类型
 * @type {{advisor: {code: string, name: string}, self_manager: {code: string, name: string}}}
 */
const constant_fund_type = {
  /** self_manager: {code: '0', name: '自主发行'}, */
  self_manager: {code: fundTypeBySelfManger, name: '自主发行'},
  /** advisor : {code : '1', name: '投顾型'} */
  advisor: {code: fundTypeByAdvisor, name: '投顾型'}
}
/**
 * 产品要素默认文本 -
 * @type {{short_line: string}}
 */
const constant_character = {
  /** 没有值 显示的 默认文本 “-” */
  short_line: '-'
}

/** 员工渠道id d1a1e70a1b0800460f492c06bea6b713 */
const directChannelYuanGong = 'd1a1e70a1b0800460f492c06bea6b713' //员工
/** 机构渠道id 262daf1817084b5fbb28acbb91133791 */
const directChannelJiGou = '262daf1817084b5fbb28acbb91133791' //机构
/** 杭州渠道id 7b0fea11c10e1f58fdba6d36e9d31fff */
const directChannelHangZhou = '7b0fea11c10e1f58fdba6d36e9d31fff' //杭州
/** 冯总渠道id 3d90a60fbf39b11cecc7708352899edb */
const directChannelFengZong = '3d90a60fbf39b11cecc7708352899edb' // 冯总
/** 个人渠道id 827f17f0bf6dcca14ad26e89e40a98a7 */
const directChannelGeRen = '827f17f0bf6dcca14ad26e89e40a98a7' //个人

/**
 * todo  直销渠道id
 * @type {{jigou_geren: (string)[], all_direct: (string)[]}}
 */
const channels = {
  /** 全部直销渠道id */
  all_direct: [directChannelYuanGong, directChannelJiGou, directChannelHangZhou, directChannelFengZong, directChannelGeRen],
  /** 机构 个人渠道id */
  jigou_geren: [directChannelJiGou, directChannelGeRen]
}

/** 身份证 00 个人证件类型*/
const creditType00 = '00'
/** 护照 01 个人证件类型*/
const creditType01 = '01'
/** 军官证 02 个人证件类型*/
const creditType02 = '02'
/** 士兵证 03 个人证件类型*/
const creditType03 = '03'
/** 港澳居民来往内地通行证 04 */
const creditType04 = '04'
/** 户口本 05 个人证件类型*/
const creditType05 = '05'
/** 外国护照 06 个人证件类型*/
const creditType06 = '06'
/** 文职证 08 个人证件类型*/
const creditType08 = '08'
/** 警官证 09 个人证件类型*/
const creditType09 = '09'
/** 台胞证 0A 个人证件类型*/
const creditType0A = '0A'
/** 港澳台居民居住证 0C 个人证件类型*/
const creditType0C = '0C'
/**
 * 其它 18 (机构证件类型 | 个人证件类型）
 * @type {string}
 */
const creditType18 = '18'

/**
 * 个人证件类型
 * @type {{id_type_00: string}}
 */
const person_credit_type = {
  // 身份证
  credit_type_00: creditType00,
  // 护照
  credit_type_01: creditType01,
  // 军官证
  credit_type_02: creditType02,
  // 士兵证
  credit_type_03: creditType03,
  // 港澳居民来往内地通行证
  credit_type_04: creditType04,
  // 户口本
  credit_type_05: creditType05,
  // 外国护照
  credit_type_06: creditType06,
  // 文职证
  credit_type_08: creditType08,
  // 警官证
  credit_type_09: creditType09,
  // 台胞证
  credit_type_0A: creditType0A,
  // 港澳台居民居住证
  credit_type_0C: creditType0C,
  // 其它
  credit_type_18: creditType18,
}


/**
 * 组织机构代码证 10
 * @type {string} 机构证件类型
 */
const creditType10 = '10'
/**
 * 营业执照号 11 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType11 = '11'

/**
 * 统一社会信用代码 31 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType31 = '31'
/**
 * 注册号 32 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType32 = '32'
/**
 * 产品备案编码 34 机构证件类型
 * @type {string}
 */
const creditType34 = '34'
/**
 * 证券业务许可证 35 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType35 = '35'
/**
 * 信托等级系统产品编码 36 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType36 = '36'
/**
 * 产品登记编码 37 机构证件类型
 * @type {string} 机构证件类型
 */
const creditType37 = '37'
/**
 * 机构证件类型
 *
 * @type {{credit_type_18: string}}
 */
const society_credit_type = {
  // 组织机构代码证
  credit_type_10: creditType10,
  // 营业执照号
  credit_type_11: creditType11,
  // 其它
  credit_type_18: creditType18,
  // 统一社会信用代码
  credit_type_31: creditType31,
  // 注册号
  credit_type_32: creditType32,
  // 产品备案编码
  credit_type_34: creditType34,
  // 证券业务许可证
  credit_type_35: creditType35,
  // 信托等级系统产品编码
  credit_type_36: creditType36,
  // 产品登记编码
  credit_type_37: creditType37
}

const client_fund_status = [
  {code: "0", name: "关注"},
  {code: "1", name: "持有"},
  {code: "2", name: "已赎回"},
  {code: "3", name: "已清算"},
]

const fund_liquidation_status_0 = "0"
const fund_liquidation_status_1 = "1"
const fund_liquidation_status_2 = "2"


/** 认申购费 提示 “认/申购费：具体费率以合同为准。” */
const subscribeRatioTypeRemark = "由销售机构收取，具体请以基金法律文件约定为准。"

/** 认申购费类型  "0" 固定费率 "1" 和 '2'都是阶梯费率*/
const subscribeRatioTypeFixed = "0"
/** 认申购费类型  "0" 固定费率  "1" 和 '2'都是阶梯费率 */
const subscribeRatioTypeStaircase1 = "1"
/** 认申购费类型  "0" 固定费率  "1" 和 '2'都是阶梯费率 */
const subscribeRatioTypeStaircase2 = "2"

/**  赎回费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0 */
const subscribeRedeemTypeFixed = "0"
/** 赎回费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0 */
const subscribeRedeemTypeStaircase1 = "1"
/** 赎回费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0  */
const subscribeRedeemTypeStaircase2 = "2"

/**  管理费费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0 */
const subscribeManagementTypeFixed = "0"
/** 管理费费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0 */
const subscribeManagementTypeStaircase1 = "1"
/** 管理费费率类型：0-固定费率、1-阶梯费率(不计头计尾)、2-阶梯费率(计头不计尾)，默认0  */
const subscribeManagementTypeStaircase2 = "2"

/** 认申购费类型映射  {"0" 固定费率 "1" 阶梯费率 "2" 阶梯费率} */
const subscribeRatioTypeMap = {
  [subscribeRatioTypeFixed]: '固定费率',
  [subscribeRatioTypeStaircase1]: '阶梯费率',
  [subscribeRatioTypeStaircase2]: '阶梯费率'
}

/**
 * todo 公告报告WPS
 * @type {string}
 */
const WpsFundNotice = 'fundNotice'
/**
 * todo 推介合同WPS
 * @type {string}
 */
const WpsFundIntroduction = 'fundIntroduction'
/**
 * todo 产品资讯WPS
 * @type {string}
 */
const WpsFundInformation = 'fundInformation'
/**
 * todo 客户适当性资料WPS
 * @type {string}
 */
const WpsClientDocument = 'clientDocument'
/**
 * todo 客户资料-适当性测试问卷WPS
 * @type {string}
 */
const WpsClientQuestionnaire = 'clientQuestionnaire'
/**
 * todo 风险评估问卷WPS
 * @type {string}
 */
const WpsRiskQuestion = 'riskQuestion'
/**
 * todo 投资者基本信息表WPS
 * @type {string}
 */
const WpsClientBasic = 'clientBasic'
/**
 *  todo 调整专业投资者确认函WPS
 * @type {string}
 */
const WpsChangeIdentity = 'changeIdentity'
/**
 * todo 风险匹配确认函WPS
 * @type {string}
 */
const WpsRiskMatching = 'riskMatching'
/**
 * todo 合同WPS
 * @type {string}
 */
const WpsFundContract = 'fundContractWx'
/**
 * todo 份额确认书、交易确认书WPS
 * @type {string}
 */
const WpsApplyConfirmPdf = 'applyConfirmPdf'



/**
 * 1 填写信息 // 2投资者判断 3风险评估(答题 -> 只有员工才答题) 4风险揭示书 资产 -> 默认资产 资产 -> 申请 资产 -> 关注 资产 -> 特别的一种(禁用的状态, 只有一个我的资产)
 * @type {{ASSETS: string, INVEST_IDENTITY: string, RISK: string, INFO: string, APPOINTS: string, RISK_REMIND: string, APPLIES: string, FORBIDDEN: string}}
 */
const UserStatus = {
  INFO: 'info', // 1 填写信息
  INVEST_IDENTITY: 'invest_identity', // 2投资者判断
  RISK: 'risk', // 3风险评估(答题 -> 只有员工才答题)
  RISK_REMIND: 'risk_remind', // 4风险揭示书
  ASSETS: 'assets', // 资产 -> 默认资产
  APPLIES: 'applies', // 资产 -> 申请
  APPOINTS: 'appoints', // 资产 -> 关注
  FORBIDDEN: 'forbidden' // 资产 -> 特别的一种(禁用的状态, 只有一个我的资产)
}

/** 性别 男 */
export const GenderBoy = '男'
/** 性别 女 */
export const GenderGirl = '女'
/** 性别 options */
export const GenderOptions = [
  {value: GenderBoy, label: GenderBoy},
  {value: GenderGirl, label: GenderGirl}
]

/**
 * 客户类型 机构 0 customer_type
 * @type {string}
 */
export const CustomerType00 = '0'
/**
 * 客户类型 个人 1 customer_type
 * @type {string}
 */
export const CustomerType01 = '1'
export const CustomerType03 = '3'
export const CustomerType04 = '4'
export const CustomerType05 = '5'
/**
 * 暂不支持机构客户线上预约，如有疑问请咨询工作人员，电话：0755-88693999。
 * @type {string}
 */
export const CustomerTypeApplyDisabledOnLine = [CustomerType00, CustomerType03, CustomerType04, CustomerType05]


/**
 *  '工作日：上午9:00-11:30，下午13:00-17:30'
 * @type {string}
 */
export const WorkdayTimeText = '工作日：上午9:00-11:30，下午13:00-17:30'
/**
 * 'SERVICE_NUMBER' '0755-88693999'
 * @type {string}
 */
//深圳电话  公司总机
export const SERVICE_NUMBER = '0755-88693999'

//上海电话号码
export const SHANGHAI_TEL = '021-20572667'

//北京电话号码
export const BEIJING_TEL = '010-56711318'

/**
 * `如有疑问，请咨询工作人员 ${SERVICE_NUMBER} ${WorkdayTimeText}`
 * @type {string}
 */
export const TelAndWorkdayTimeText = `如有疑问，请咨询工作人员 ${SERVICE_NUMBER} ${WorkdayTimeText}`

/**
 * 产品要素页面提醒文案
 */
export const FundFactorRemindText = `本基金可能发生过变更，本页面展示的是本基金变更后的产品基本信息，仅供基金投资者参考。`


/**
 * 区分是投资报告（投资报告，信息披露报告）还是其他报告
 * 0：表示其他公告与报告
 * 1：表示投资报告
 * @type {number}
 */
export const NoticeTypeOther = 0;
export const NoticeTypeInvest = 1;

/**
 * 投资报告类型
 * 0: 投资月报
 * 1: 信息披露报告
 * @type {number}
 */
export const MonthlyTypeInvestReport = 0;
export const MonthlyTypeDisclosureReport = 1;


/**
 * 沙龙问卷 根据 id 禁用其他id 特殊逻辑 后台修改 需要同步修改 start
 */
// 第6题“您的投资经验可描述为”，选择“a.除银行储蓄外，基本没有其他投资经验”，则第7题“您有多少年投资基金、股票、信托、私募证券或金融衍生产品等风险投资品的经验”仅能选择“a.没有经验”，不能选择与第6题a选项矛盾的b/c/d/e任一选项。
export  const MSQOfTypeOptionId060A  = 284
export  const MSQOfTypeOptionId070B  = 289
export  const MSQOfTypeOptionId070C  = 290
export  const MSQOfTypeOptionId070D  = 291
export  const MSQOfTypeOptionId070E  = 292
export  const MSQOfTypeOptionId07Disabled = [MSQOfTypeOptionId070B,MSQOfTypeOptionId070C,MSQOfTypeOptionId070D,MSQOfTypeOptionId070E]
export const MSQDescription02 = `如您已如实填写本《合格投资者确认及风险属性评估问卷》请您点击“确认提交”，如有问题，请联系工作人员 ${SERVICE_NUMBER}（${WorkdayTimeText}）`

/**
 * 沙龙问卷 根据 id 禁用其他id 特殊逻辑 后台修改 需要同步修改 end
 */

/**
 * 是 '1'
 * @type {string}
 */
const YES = '1'
/**
 * 否 '0'
 * @type {string}
 */
const NO = '0'

/**
 * 投资者的类型
 */
export const InvestorTypes = [
  {name: '个人投资者', code: '1'},
  {name: '机构投资者', code: '0'}
]



export default {
  constant_trade_type,
  constant_character,
  fundTypeBySelfManger,
  fundTypeByAdvisor,
  constant_fund_type,
  channels,
  person_credit_type,
  society_credit_type,
  subscribeRatioTypeFixed,
  subscribeRatioTypeStaircase1,
  subscribeRatioTypeStaircase2,
  subscribeRatioTypeRemark,
  subscribeRatioTypeMap,
  subscribeRedeemTypeFixed,
  subscribeRedeemTypeStaircase1,
  subscribeRedeemTypeStaircase2,
  subscribeManagementTypeFixed,
  subscribeManagementTypeStaircase1,
  subscribeManagementTypeStaircase2,
  WpsFundNotice,
  WpsFundIntroduction,
  WpsFundInformation,
  WpsClientDocument,
  WpsClientQuestionnaire,
  WpsRiskQuestion,
  WpsClientBasic,
  WpsChangeIdentity,
  WpsRiskMatching,
  WpsFundContract,
  WpsApplyConfirmPdf,
  directChannelYuanGong,
  directChannelJiGou,
  directChannelHangZhou,
  directChannelFengZong,
  directChannelGeRen,
  creditType00,
  creditType01,
  creditType02,
  creditType03,
  creditType04,
  creditType05,
  creditType06,
  creditType08,
  creditType09,
  creditType0A,
  creditType0C,
  creditType18,
  creditType10,
  creditType11,
  creditType31,
  creditType32,
  creditType34,
  creditType35,
  creditType36,
  creditType37,
  subscribeCode,
  subscriptionCode,
  redeemCode,
  bonusCode,
  transferInCode,
  transferOutCode,
  rewardDeductionShareCode,
  rewardDeductionAmoutCode,
  subscribeName,
  subscriptionName,
  redeemName,
  bonusName,
  transferInName,
  transferOutName,
  rewardDeductionShareName,
  rewardDeductionAmoutName,
  addName,
  UserStatus,
  hongLiZhuangTouName,
  GenderBoy,
  GenderGirl,
  GenderOptions,
  CustomerType00,
  WorkdayTimeText,
  SERVICE_NUMBER,
  TelAndWorkdayTimeText,
  NoticeTypeOther,
  NoticeTypeInvest,
  MonthlyTypeInvestReport,
  MonthlyTypeDisclosureReport,
  YES,
  NO,
  InvestorTypes,
  client_fund_status,
  fund_liquidation_status_0,
  fund_liquidation_status_1,
  fund_liquidation_status_2,
  FundFactorRemindText
}
